<template>
    <div class="store-tip" :class="[storeTipShow]">
        <div class="info">
            <i class="ico iconfont">&#xe6cc;</i>
            <h3 style="margin-top:1rem;">{{storeTipTitle}}</h3>
            <p class="text">{{storeTipText}}</p>
            <em class="back" style="margin-right:.5rem;background:#e8864c" @click="hide">{{ $t('general.continue') }}</em>
            <em class="back" style="margin-left:.5rem;"  @click="$router.go(-1)">{{ $t('general.rechoose') }}</em>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: 'StoredetailTip',
  data () {
    return {
      storeTipShow:'hide'
    }
  },
  props: {
    store: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    ...mapState({
      storeInfo: (state) => state.goodsdetail.storeInfo,
    }),
    storeTipText () {
      if (this.store.is_o2o_state !== true) {
        // 判断店铺是否在营业时间内
        return this.$t(`store.o2o_state.${this.store.is_o2o_state}`)
      }
    },

    storeTipTitle () {
      if (!this.store.is_o2o_state) {
        // 判断店铺是否在营业时间内
        return this.store.o2o_state_title
      } else if (!this.store.is_o2o_support) {
        // 判断店铺是否支持配送
        return this.$t('store.alerts.no_deliver')
      }
    }
  },
  created () {
      if (this.store.is_o2o_state === undefined || this.store.is_o2o_support === undefined) {
        // 因在未获取数据之前默认会渲染一次 所以默认为隐藏
        this.storeTipShow='hide'
      } else if (this.store.is_o2o_state !== true || !this.store.is_o2o_support) {
        this.storeTipShow='show'
      } else {
        this.storeTipShow='hide'
      }
  },
  mounted () {

  },
  methods: {
    hide () {
      this.storeTipShow='hide'
    }
  }

}
</script>

<style scoped>
    .store-tip{width:100%;height:100%;background: rgba(7,17,27,0.8);color: #fff;position:fixed;z-index: 100;top: 0;left: 0;display:none;}
    .hide{display:none}
    .show{display:block}
    .info{position: absolute;width:100%;height: 1.5rem;left: 0;top:30%;text-align:center;}
    .info .ico{display:block;font-size: 5rem;text-align:center;color: #f90;}
    .info .hide{display:block;text-align:center;margin-top:5rem;}
    .info .text{margin:1rem auto 1.5rem; line-height:1.5rem; width: 70vw; word-break: keep-all;}
    .info .back{text-align:center;margin-top:2rem;background:#f90;padding:.4rem 1rem;font-size:.7rem;}
</style>
